import {IconType} from './icon';

/**
 * Maps IconType to PrimeNG icon class suffix
 * @param iconType - The semantic icon type
 * @returns The PrimeNG icon class (e.g., 'pi-euro')
 */
export function mapIconTypeToPrimeIcon(iconType: IconType): string {
  switch (iconType) {
    case 'finances':
      return 'pi-euro';
    case 'plus':
      return 'pi-plus';
    case 'map':
      return 'pi-map-marker';
    case 'user':
      return 'pi-user';
    case 'server':
      return 'pi-server';
    case 'AI':
      return 'pi-sparkles';
    case 'building':
      return 'pi-building';
    case 'users':
      return 'pi-users';
    case 'save':
      return 'pi-save';
    case 'edit':
      return 'pi-pencil';
    case 'delete':
      return 'pi-trash';
    case 'search':
      return 'pi-search';
    case 'bell':
      return 'pi-bell';
    case 'play':
      return 'pi-play';
    case 'setting':
      return 'pi-cog';
    case 'clock':
      return 'pi-clock';
    case 'dashboard':
      return 'pi-th-large';
    case 'top-right-arrow':
      return 'pi-arrow-up-right';
    case 'bottom-right-arrow':
      return 'pi-arrow-down-right';
    case 'right-arrow':
      return 'pi-arrow-right';
    case 'todo':
      return 'pi-clipboard';
    case 'expand':
      return 'pi-chevron-down';
    case 'collapse':
      return 'pi-chevron-up';
    case 'filter':
      return 'pi-filter';
    case 'chevron-left':
      return 'pi-chevron-left';
    case 'chevron-down':
      return 'pi-chevron-down';
    case 'chevron-right':
      return 'pi-chevron-right';
    case 'minus':
      return 'pi-minus';
    case 'columns':
      return 'pi-table';
    case 'check':
      return 'pi-check';
    case 'tag':
      return 'pi-tag';
    case 'lock':
      return 'pi-lock';
    case 'timesheets':
      return 'pi-inbox';
    case 'file':
      return 'pi-file';
    case 'folder-open':
      return 'pi-folder-open';
    case 'folder':
      return 'pi-folder';
    case 'download':
      return 'pi-download';
    case 'phone':
      return 'pi-phone';
    case 'chart-line':
      return 'pi-chart-line';
    case 'credit-note':
      return 'pi-inbox';
    case 'globe':
      return 'pi-globe';
    case 'attachment':
      return 'pi-paperclip';
    case 'credit-card':
      return 'pi-credit-card';
    case 'send':
      return 'pi-send';
    case 'clone':

      return 'pi-clone';
    case 'copy':
      return 'pi-copy';
    case 'percentage':
      return 'pi-percentage';
    case 'align-center':
      return 'pi-align-center';
    case 'warning':
      return 'pi-exclamation-triangle';
    case 'sync':
      return 'pi-sync';
    case 'bolt':
      return 'pi-bolt';
    case 'box':
      return 'pi-box';
    case 'stop':
      return 'pi-stop-circle';
    default:
      return '';
  }
}
